import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchPageComponent } from "./pages/search-page/search-page.component";
import { ResultsPageComponent } from "./pages/results-page/results-page.component";
import { DetailsPageComponent } from "./pages/details-page/details-page.component";
import { NotFoundPageComponent } from "./pages/not-found-page/not-found-page.component";
import { DownloadPageComponent } from "./pages/download-page/download-page.component";
import { GlossaryPageComponent } from './pages/glossary-page/glossary-page.component';
import { InfoAifaPageComponent } from './pages/info-aifa-page/info-aifa-page.component';

const routes: Routes = [
  { path: 'risultati', component: ResultsPageComponent },
  { path: 'dettaglio/:id', component: DetailsPageComponent },
  { path: 'glossario', component: GlossaryPageComponent },
  { path: 'organizzazione/:sis_code/farmaci/:aic6/stampati/:type', component: DownloadPageComponent },
  { path: 'info_aifa', component: InfoAifaPageComponent },
  { path: '', component: SearchPageComponent },
  { path: '**', component: NotFoundPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      // Tell the router to use the hash instead of HTML5 pushstate.
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
